import { axios as request } from "../../request/http";

const interfaceUrl = {
    "api_productCategoryAll": "/product/category/queryAll", // 查询所有类目
}

// initial state
const state = {
    productCategoryAll: [],
}

// getters
const getters = {
    getProductCategoryAll: state => {
        return state.productCategoryAll
    },
}

// actions
const actions = {
    getProductCategoryAll: ({
        commit,
        state
    }, params) => {
        params = params || {};
        let option = {
            url: interfaceUrl.api_productCategoryAll,
            method: "GET",
            params,
        };
        return request(option).then(res => res.data).then(res => {
            if (res.code == 200) {
                commit('PRODUCT_CATEGORY_ALL', res.data || []);
            } else {
                commit('PRODUCT_CATEGORY_ALL', []);
            }
        }).catch(err => {
            commit('PRODUCT_CATEGORY_ALL', []);
        })
    },
}


// mutations
const mutations = {
    PRODUCT_CATEGORY_LIST: (state, pageData) => {
        state.productCategoryList = pageData;
    },
    PRODUCT_CATEGORY_ALL: (state, pageData) => {
        state.productCategoryAll = pageData;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/category.js